import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import '../App.css';

function MasterTemplate({ master_template, on_change, on_save, saving }) {
	const [show_editor, set_show_editor] = useState(false);

	const toggle = () => {
		set_show_editor(function(prev) {
			return !prev;
		});
	};

	return (
		<div className="admin-master-section">
			<div className="admin-master-header" onClick={toggle}>
				<h6 className="admin-form-section-title">Master Template</h6>
				<span className="admin-master-toggle">{show_editor ? '▲ Hide' : '▼ Edit'}</span>
			</div>
			{show_editor ? (
				<React.Fragment>
					<Form.Control
						as="textarea"
						className="admin-preview-textarea"
						value={master_template}
						rows={20}
						onChange={function(e) { return on_change(e.target.value); }}
					/>
					<Button
						variant="outline-secondary"
						className="admin-master-save-btn"
						onClick={on_save}
						disabled={saving}>
						Save Master Template
					</Button>
				</React.Fragment>
			) : null}
		</div>
	);
}

export default MasterTemplate;
